<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">车牌列表</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 车牌列表 开始 -->
    <div class="licese_list">
      <div class="licese_box" v-for="(item,index) in  licenseList " @click="buttonClicked ? '' : taplist(index)">
        <div class="licese_box_left">
          <div class="licese_redio" v-if="isSelectLicense">
            <!-- <input type="radio" :checked="item.checked" /> -->
            <img class="checkimg" :src="item.checked?'/static/newicon/checkedicon.png' : '/static/newicon/checkicon.png'" />
          </div>
          <div class="licese_mesg">
            <div class="licese_me">{{item.car_no}}</div>
            <div class="licese_me">{{item.owner}}</div>
            <!-- <div class="licese_num">{{ item.card_no }}</div> -->
          </div>
        </div>

        <img class="licese_shanchu" src="/static/newprojecticon/del.png" @click.stop="tap('liceseIndexDelete',index)" />
      </div>
      <div style="height:70px;"></div>
    </div>
    <!-- 车牌列表 结束 -->
    <!-- 新增车牌 开始 -->
    <div class="page_button liceselist_button" hover-class="commonBg" @click="tap('toLicenseAdd')">
      <div class="page_zhifu">新增车牌</div>
    </div>
    <!-- 新增车牌 结束 -->
    <!-- 暂无信息  开始 -->
    <div class="page_none lice_none" v-if="licenseList.length==0">
      <img src="/static/newprojecticon/zanwujilu.png" class="page_none_icon" />
    </div>
    <!-- 暂无信息  结束 -->
  </div>
</template>

<script>
  // import swal from 'sweetalert'
  import httper from '../../api/http'
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        licenseList: [], // 接口获取车信息列表,默认为空
        licenseIndex: 0, // 车信息指针,默认为0
        buttonClicked: false, // 防止用户重复点击,默认为false
        product_id: "", //上页面传来商品id
        isSelectLicense: false,
        name: "", //上个页面传来的联系人姓名
        phone: "", //上页面传来联系人电话
        address: "", //上页面传来联系人地址
        date: "",
        time: "",
        isAppointment: false,
        storeDesc: {},
        store_id: "",
        product_name: "",
        product_type:"",
        city:"",
        address11:"",//详细地址
      }
    },
    created() {
      if (this.$route.query.product_id) {
        this.product_id = this.$route.query.product_id
      }
      if (this.$route.query.product_name) {
        this.product_name = this.$route.query.product_name;
      } else {
        this.product_name = "";
      }

      //上页面获取商品服务类型
      if (this.$route.query.product_type) {
        this.product_type = this.$route.query.product_type;
      } else {
        this.product_type = "";
      }

      if (this.$route.query.isSelectLicense) {
        this.isSelectLicense = this.$route.query.isSelectLicense
      }
      if (this.$route.query.name) {
        this.name = this.$route.query.name
      }
      if (this.$route.query.phone) {
        this.phone = this.$route.query.phone
      }
      if (this.$route.query.address) {
        this.address = this.$route.query.address
      }
      if (this.$route.query.address11) {
        this.address11 = this.$route.query.address11
      }
      if (this.$route.query.date) {
        this.date = this.$route.query.date;
      } else {
        this.date = "";
      }
      if (this.$route.query.time) {
        this.time = this.$route.query.time;
      } else {
        this.time = "";
      }
      if (this.$route.query.isAppointment) {
        this.isAppointment = this.$route.query.isAppointment;
      } else {
        this.isAppointment = false;
      }
      if (this.$route.query.store_id) {
        this.store_id = this.$route.query.store_id;
      } else {
        this.store_id = "";
      }
      if (this.$route.query.city) {
        this.city = this.$route.query.city;
      } else {
        this.city = "";
      }
    },
    mounted() {
      this.request('getLicenseList')
    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      // 跳转到编辑车信息页
      toLicenseEdit(index) {
        this.$router.push({
          path: '/licenseEdit',
          query: {
            index: index
          }
        })
      },
      tap(e, params = '') {
        let that = this
        switch (e) {
          //跳转添加车信息页
          case 'toLicenseAdd':
            this.$router.push({
              path: '/CarLicenseAdd',
              query: {
                isedit: 0
              }
            })
            break
          case 'liceseIndexDelete':
            Dialog.confirm({
                title: '提示',
                message: '确认删除?',
              })
              .then(() => {
                let requestData = {
                  id: that.licenseList[Number(params)].id,
                  index: Number(params)
                }
                this.request('delCar', requestData)
                this.request("getLicenseList")
              })
              .catch(() => {
                return false;
              });
            break
        }
      },
      taplist(e) {
        let that = this
        var licenseList = this.licenseList
        if (this.buttonClicked) return
        that.buttonClickedFun(1000)
        licenseList.map((item, index) => item.checked = index === e)
        that.licenseIndex = Number(e)
        that.licenseList = licenseList
        var licenseItem = that.licenseList[e]

        if (this.isSelectLicense) {
          if (this.isAppointment) {
            that.$router.push({
              path: '/appointmentYearInsp',
              query: {
                licenseItem: JSON.stringify(licenseItem),
                product_id: this.product_id,
                name: this.name, //上个页面传来的联系人姓名
                phone: this.phone, //上页面传来联系人电话
                address: this.address, //上页面传来联系人地址
                date: this.date,
                time: this.time,
                store_id: this.store_id,
                product_name : this.product_name,
                product_type:this.product_type,
                city:this.city
              }
            })
          } else {
            that.$router.push({
              path: '/yearlyInspection',
              query: {
                licenseItem:JSON.stringify(licenseItem),
                product_id: this.product_id,
                name: this.name, //上个页面传来的联系人姓名
                phone: this.phone, //上页面传来联系人电话
                address: this.address, //上页面传来联系人地址
                address11: this.address11, //上页面传来联系人详细地址
                date: this.date,
                time: this.time,
                store_id: this.store_id,
                product_name : this.product_name,
                product_type:this.product_type,
                city:this.city
              }
            })
          }

        } else {
          that.$router.push({
            path: '/CarLicenseAdd',
            query: {
              licenseItem: licenseItem,
              isedit: 1
            }
          })
        }


        // that.$router.push({
        //   name: 'reserveDesc',
        //   // query: {
        //   //   licenseItem: licenseItem,
        //   //   id:that.id
        //   // }
        // })
      },
      request(type = '', requestData = {}) {
        let that = this
        let data = {}
        switch (type) {
          // 获取行驶证列表user/car-list /user/car-driving-license /user/driving-license-list
          case 'getLicenseList':
            httper.get('/user/driving-license-list', requestData, res => {
              res.data.map((item, index) => item.checked = index === that.licenseIndex)
              that.licenseList = res.data
            })
            break
            // 删除行驶证user/del-car /user/del-driving-license
          case 'delCar':
            httper.get('/user/del-driving-license', requestData, res => {
              if (res.code === 0) {
                window.location.reload()
              } else {
                this.$toast({
                  message: '删除失败',
                })
              }
            }, true)
            break
        }
      }
    }
  }
</script>

<style scoped>
  .licese_list {
    width: 90%;
    padding: 20px;
  }

  .licese_box {
    width: 100%;
    height: 76px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .licese_box_left {
    display: flex;
    align-items: center;
  }

  .licese_redio {
    margin-right: 10px;
    width: 14px;
    height: 14px;
  }

  .licese_mesg {
    display: flex;
    flex-direction: column;
  }

  .licese_me {
    font-size: 14px;
    font-weight: 400;
    color: rgba(54, 54, 54, 1);

  }

  .licese_num {
    font-size: 10px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .licese_shanchu {
    width: 19px;
    height: 19px;
  }

  .liceselist_button {
    position: fixed;
    bottom: 50px;
  }

  .checkimg {
    width: 14px;
    height: 14px;
  }

  .lice_none {
    left: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/CarLicenseList.vue